import React from 'react'
import styled, { keyframes } from 'styled-components'
import tw from 'twin.macro'
import { useTranslation } from 'contexts/Localization'
import { Overlay } from 'views/Bonuses/styles'
import { fadeIn } from 'react-animations'
import { ArrowUpIcon, Flex } from '@nominex/dex-uikit'
import { SlButton } from '@shoelace-style/shoelace/dist/react'

export const fadeInAnimation = keyframes`${fadeIn}`

const IconWrapper = styled(Flex)`
  background: ${({ theme }) => theme.colors.gradients.primary};
  ${tw`w-[84px] h-[84px] rounded-[9999px] items-center justify-center`}
`
const OverlayWrapper = styled(Flex)`
  animation: 0.5s ${fadeInAnimation};
  backdrop-filter: blur(15px);
  background: ${({ theme }) => `${theme.colors.darkGray900}66`};
  ${tw`flex-col gap-24 justify-center items-center absolute left-[2px] right-[2px] bottom-[2px] top-[67px] z-10 rounded-b-12`}
`

const SuccessfulClaimOverlay: React.FC<{ onDismiss: () => void }> = ({ onDismiss }) => {
  const { t } = useTranslation()

  return (
    <OverlayWrapper>
      <Overlay
        icon={
          <IconWrapper>
            <ArrowUpIcon color="white" width="36px" height="36px" />
          </IconWrapper>
        }
        title={t('Rewards successfully claimed')}
        description={t('Your NMX rewards have been sent to your wallet. They will be accounted within few minutes.')}
        flexGap="24px"
      />
      <SlButton variant="primary" onClick={onDismiss}>
        {t('Close')}
      </SlButton>
    </OverlayWrapper>
  )
}

export default SuccessfulClaimOverlay
